import { render } from "./Dezimal.vue?vue&type=template&id=4ad57868&scoped=true"
import script from "./Dezimal.vue?vue&type=script&lang=js"
export * from "./Dezimal.vue?vue&type=script&lang=js"

import "./Dezimal.vue?vue&type=style&index=0&id=4ad57868&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad57868"]])

export default __exports__